import {
  applyDensityToDOM,
  setDensityPreference,
} from "@/lib/utils/design/theme-cookies";
import { logger } from "@/lib/utils/logger";

export function applyOptimisticUiPreferences(prefs: Record<string, unknown>) {
  try {
    // Theme is handled by ThemeModeProvider — only density needs optimistic DOM apply
    if ("density" in prefs) {
      const density = prefs.density as string | undefined;
      if (density) {
        setDensityPreference(density);
        applyDensityToDOM(density);
      }
    }
  } catch (error) {
    logger.debug("Failed to apply optimistic UI update", { error });
  }
}
